// export const API_URL = "http://localhost:6002/";
// export const API_URL = "http://167.71.95.212:6002/";
export const API_URL = "https://back-agent.mkaitechnology.com/";